import { useDocumentViewerController } from '@dealstack/frontend/shared/components/DocumentViewer/useDocumentViewerController';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { DOCUMENT_TYPE } from '@dealstack/shared/lib/common/file/file';
import { forwardRef, lazy, memo, Suspense } from 'react';
import styled from 'styled-components';
import type { IDocumentViewerProps } from './DocumentViewer.types';

const PdfLoader = lazy(() =>
	import('@dealstack/frontend/shared/components/PdfLoader/PdfLoader').then((m) => ({
		default: m.PdfLoader,
	}))
);
const DocumentViewer = forwardRef<HTMLDivElement, IDocumentViewerProps>(
	({ className, pdfLoaderProps, file, fileExtension, onClose }, ref) => {
		const documentViewerController = useDocumentViewerController({
			file,
			fileExtension,
		});

		return (
			<div className={className} ref={ref}>
				{documentViewerController.documentType ? (
					<DocumentViewerWrapper>
						{documentViewerController.documentType === DOCUMENT_TYPE.IMAGE ? (
							<DocumentViewerImage
								ref={documentViewerController.imageRef}
								alt=""
								src={file as string}
							/>
						) : null}
						{documentViewerController.documentType === DOCUMENT_TYPE.PDF ? (
							<Suspense fallback={<InlineLoader />}>
								<DocumentViewerPDF
									{...pdfLoaderProps}
									src={file}
									onClose={onClose}
								/>
							</Suspense>
						) : null}
					</DocumentViewerWrapper>
				) : (
					<InlineLoader />
				)}
			</div>
		);
	}
);
const DocumentViewerWrapper = styled.div``;
const DocumentViewerImage = styled.img``;
const DocumentViewerPDF = styled(PdfLoader)``;

const Memoized = memo(DocumentViewer);
const Styled = styled(Memoized)``;

export { Styled as DocumentViewer };
